module.exports = __webpack_public_path__ + "img/sj3.2c01fc35.jpeg";